'use client'

import ImageLoading from '@/components/ImageLoading'
import { useItineraryStoreV2 } from '@/core/stores/itinerary/itineraryV2'

export default function ParticipantImage({ userId, size = '40px', image }:
    { userId: string, size?: string, image?: string | null }) {
    const { users } = useItineraryStoreV2()

    const finalImage = image || users?.[userId]?.image

    const sharedClassName = ' rounded-full aspect-square'
    const sharedStyle = { width: size, height: size }

    const imageElement = finalImage ? (
        <div style={sharedStyle} className=''>
            <ImageLoading
                style={sharedStyle}
                width={100}
                height={100}
                src={finalImage}
                className={`object-cover  rounded-full block overflow-hidden ${sharedClassName}`}
                alt="Planingo"
            />
        </div>
    ) : (
        <div
            style={sharedStyle}
            className={`bg-slate-200 animate-pulse ${sharedClassName}`}
        />
    )

    return imageElement
}
